import React from "react";
// Import Link
import { Link } from "react-router-dom";

const CommonCard = (props) => {
  return (
    <>
      <div
        className={
          props.grid === true
            ? "col-lg-4 col-md-6 col-sm-6 col-12"
            : "col-lg-3 col-md-6 col-sm-6 col-12"
        }
      >
        <div className="theme_common_box_two img_hover">
          <div className="theme_two_box_img">
            <Link to={props.url}>
              <img src={props.img} alt="img" />
            </Link>
            <p>
              <i className="fas fa-map-marker-alt"></i>
              {props.location}
            </p>
            {props.discount === true ? (
              <div className="discount_tab">
                <span>{props.discountPrice}</span>
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="theme_two_box_content">
            <h4>
              {" "}
              <Link to={props.url}>{props.heading}</Link>
            </h4>
            <p>
              <span className="review_rating">{props.reviewRating}</span>
              <span className="review_count">{props.reviewCount}</span>
            </p>
            <a
              href="https://wa.me/923449992333?text=Hey%20I%20want%20to%20know%20more%20details"
              className="btn btn_theme btn_sm"
              target="_blank"
            >
              Get Offer
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default CommonCard;
